function FormError(props) {
	return <div className="text-[13px] text-red-500 absolute top-0 left-0">{props?.children}</div>
}

export default FormError
